<template>
  <v-container>
    <h2>
      Which best describes your practice?
    </h2>

    <div class="button-group vertical stretch">
      <button
        v-for="(item, index) in practiceTypes"
        :key="`practice-choice-${index}`"
        class="default-btn blue"
        @click="onPracticeSelect(item.name)"
      >{{ item.title || item.name }}</button>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'QuestionnairePracticeStep',
  computed: {
    ...mapState('questionnaireStore', {
      practiceTypes: ({ questions }) => questions ? questions.practiceTypes : [],
    }),
  },
  methods: {
    ...mapActions('questionnaireStore', ['updateMatchData']),
    async onPracticeSelect (item) {
      await this.updateMatchData({ practiceType: item })
      this.$emit('finished')
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .button-group {
    grid-template-columns: 90%;

    @include md {
      grid-template-columns: 350px;
    }

    .default-btn {
      margin: 0 auto;
      padding: 5px;
      width: 100%;
    }
  }
}
</style>
